import React from 'react';
import { useParams } from "react-router-dom";
import FlexicoAuditLogging from './FlexicoAuditLogging';

export default (props) => {
    let { id } = useParams();
    let { fid } = useParams();
    
    return <FlexicoAuditLogging id={id} fid={fid} location={props.location} />;
}
